import { LANTERN_ORIGIN, SKULL_ORIGIN, terrainHeight, type Landmass } from "@tiny-seas/shared";

/** Rendered terrain grid spacing: Lantern and Skull's authored relief and cliff-walled islands need finer grids. */
export function terrainStep(l: Landmass): number {
  const authored = (l.cx === LANTERN_ORIGIN.x && l.cz === LANTERN_ORIGIN.z) || (l.cx === SKULL_ORIGIN.x && l.cz === SKULL_ORIGIN.z);
  return authored ? 1 : l.mesas ? 1.5 : l.radius > 60 ? 3 : 2;
}

/** Matches the unchanged rendered terrain's triangle interpolation for low surface dressing. */
export function terrainSurfaceHeight(l: Landmass, x: number, z: number): number {
  const step = terrainStep(l), ox = l.cx - l.radius * 1.75, oz = l.cz - l.radius * 1.75;
  const gx = (x - ox) / step, gz = (z - oz) / step;
  const ix = Math.floor(gx), iz = Math.floor(gz), u = gx - ix, v = gz - iz;
  const x0 = ox + ix * step, z0 = oz + iz * step;
  const b = terrainHeight(x0 + step, z0), c = terrainHeight(x0, z0 + step);
  if (u + v <= 1) { const a = terrainHeight(x0, z0); return a + (b - a) * u + (c - a) * v; }
  const d = terrainHeight(x0 + step, z0 + step);
  return d + (c - d) * (1 - u) + (b - d) * (1 - v);
}
